import { z } from 'zod'

// Só tipos e schemas do contrato de `GET/POST entity/orders/:id/financeiro`.
// A regra da Situação financeira mora no api; aqui só se exibe o que ele devolve.

export const SituacaoFinanceiraSchema = z.enum([
  'SEM_COBRANCA',
  'EM_DIA',
  'ATRASADA',
  'PAGA',
])
export type SituacaoFinanceira = z.infer<typeof SituacaoFinanceiraSchema>

export const EstadoParcelaSchema = z.enum([
  'RECEBIDA',
  'EM_ABERTO',
  'ATRASADA',
  'IGNORADA',
])
export type EstadoParcela = z.infer<typeof EstadoParcelaSchema>

// Uma parcela cuja cópia local ainda não foi preenchida vem com quase tudo null.
export const ParcelaOrdemSchema = z.object({
  id: z.string(),
  evento_financeiro_id: z.string(),
  descricao: z.string().nullable(),
  valor: z.number().nullable(),
  valor_pago: z.number().nullable(),
  data_vencimento: z.string().nullable(),
  data_pagamento: z.string().nullable(),
  // Status da Conta Azul; texto livre para um valor novo nunca quebrar a tela.
  status: z.string().nullable(),
  metodo_pagamento: z.string().nullable(),
  sincronizada_em: z.string().nullable(),
  estado: EstadoParcelaSchema,
})
export type ParcelaOrdem = z.infer<typeof ParcelaOrdemSchema>

export const AtualizacaoSchema = z.enum([
  'NAO_SOLICITADA',
  'NAO_NECESSARIA',
  'REALIZADA',
  'FALHOU',
])
export type Atualizacao = z.infer<typeof AtualizacaoSchema>

export const FinanceiroOrdemSchema = z.object({
  situacao: SituacaoFinanceiraSchema,
  parcelas: z.array(ParcelaOrdemSchema),
  sincronizada_em: z.string().nullable(),
  atualizacao: AtualizacaoSchema,
})
export type FinanceiroOrdem = z.infer<typeof FinanceiroOrdemSchema>

export type ModoAtualizar = 'nao' | 'se_antiga' | 'sempre'

export const StatusSolicitacaoSchema = z.enum([
  'CRIADA',
  'PENDENTE',
  'ENVIANDO',
  'FALHOU',
])
export type StatusSolicitacao = z.infer<typeof StatusSolicitacaoSchema>

export const RespostaCriacaoSchema = z.object({
  integracao: z.object({
    solicitacao: z.object({
      id: z.string(),
      status: StatusSolicitacaoSchema,
    }),
  }),
  // Motivo devolvido pela Conta Azul quando FALHOU; formato livre.
  erro: z.unknown().optional(),
})
export type RespostaCriacao = z.infer<typeof RespostaCriacaoSchema>

export interface NovaCobranca {
  descricao: string
  metodo_pagamento: string
  parcelas: Array<{ data_vencimento: string; valor: number }>
}
